module.exports = __webpack_public_path__ + "static/img/icon-calendar-red.0b4f1aa.png";